import { useParams, Navigate } from "react-router";
import { Container } from "./styled";
import { Typography } from "../../components";

const target_group_urls = {
    'lactatiekunde': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-lactatiekunde',
    'verloskunde': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-verloskunde',
    'kraamzorg': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-kraamzorg',
    'jgz': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-jgz',
    'huisarts': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-huisarts',
    'ziekenhuis': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-ziekenhuis',
    'gemeenten': 'team/nolia.babyfeeding/verkennend-gesprek-nolia-babyfeeding-gemeenten',
};

export default function GesprekDoelgroep(props) {
    let params = useParams();
    let { target_group } = params;

    // If wrong url was used, redirect to "gesprek" homepage
    if (!Object.keys(target_group_urls).includes(target_group)) {
        return <Navigate to='/gesprek' />
    }

    // Bouw de volledige iframe URL met www.tidycal.com
    const tidycalIframeUrl = `https://www.tidycal.com/${target_group_urls[target_group]}?embed=1`;

    return (
        <Container>
            <Typography type='h2'>Plan hier meteen jouw gesprek</Typography>
            <div style={{ width: '80%', margin: '2vw 0 0 0' }}>
                <iframe
                    src={tidycalIframeUrl}
                    style={{ width: '100%', height: '700px', border: 'none' }}
                    title="TidyCal Booking"
                />
            </div>
        </Container>
    )
}